import { render, staticRenderFns } from "./HTMLContentMagento.vue?vue&type=template&id=6e5f74ac&"
import script from "./HTMLContentMagento.vue?vue&type=script&lang=ts&"
export * from "./HTMLContentMagento.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports